import { cx } from '@linaria/core';

import { SizeCommonButtonBase } from '../ButtonBase/SizeCommonButtonBase';
import type { SizeButtonBaseProps } from '../ButtonBase/types';
import { styledButton } from './styles';

export const ButtonGhost = ({ className, ...props }: SizeButtonBaseProps) => {
	return (
		<SizeCommonButtonBase className={cx(className, styledButton)} {...props} />
	);
};
